module.exports = __webpack_public_path__ + "static/icon-873e8b1312e6a634d00f976fb83eb3e8.png";